import React from "react";

const focuses = [
  {
    step: "01",
    title: "Websites",
    text: "Public sites with a clear visual direction — catalogs, hotels, and brand pages that feel considered and stay easy to use.",
    color: "#1d4ed8",
  },
  {
    step: "02",
    title: "Systems",
    text: "The software behind the business: admin, API, roles, and the records a team actually works from every day.",
    color: "#6d28d9",
  },
  {
    step: "03",
    title: "Mobile",
    text: "Apps for the floor — camera, barcode, and offline — on the same API as the office.",
    color: "#0f766e",
  },
];

const skills = [
  "React",
  "Laravel",
  "React Native",
  "MySQL",
  "APIs",
  "Tailwind CSS",
  "Next.js",
];

const About = () => {
  return (
    <section id="about" className="scroll-mt-24 border-t border-ink/10 bg-white py-20 text-ink lg:py-24">
      <div className="site-wrap">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <p className="label">About Me</p>
            <h2 className="mt-3 max-w-xl text-3xl font-light tracking-tight sm:text-5xl">
              Websites people visit. Systems teams run.
            </h2>
          </div>
          <p className="max-w-md text-[15px] leading-relaxed text-ink/65 lg:col-span-5">
            I’m Lisa, a fullstack designer and developer. I design the public
            site and build the product behind it — React on the screen, Laravel
            and MySQL underneath, React Native when the work is on a phone.
          </p>
        </div>

        <div className="mt-12 grid gap-4 md:grid-cols-3">
          {focuses.map((item) => (
            <article key={item.step} className="process-card">
              <p className="font-mono text-[11px]" style={{ color: item.color }}>{item.step}</p>
              <h3 className="mt-8 text-2xl font-light">{item.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-ink/60">{item.text}</p>
              <span className="process-ghost" style={{ color: item.color, opacity: 0.2 }}>{item.step}</span>
            </article>
          ))}
        </div>

        <ul className="mt-8 flex flex-wrap gap-x-5 gap-y-2">
          {skills.map((skill) => (
            <li key={skill} className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink/45">
              {skill}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default About;
